'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakWords = exports.fromCodePoint = exports.toCodePoints = undefined;

var _cssLineBreak = require('css-line-break');

Object.defineProperty(exports, 'toCodePoints', {
  enumerable: true,
  get: function get() {
    return _cssLineBreak.toCodePoints;
  }
});
Object.defineProperty(exports, 'fromCodePoint', {
  enumerable: true,
  get: function get() {
    return _cssLineBreak.fromCodePoint;
  }
});

var _NodeContainer = require('./NodeContainer');

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _overflowWrap = require('./parsing/overflowWrap');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var breakWords = exports.breakWords = function breakWords(str, parent) {
  var breaker = (0, _cssLineBreak.LineBreaker)(str, {
    lineBreak: parent.style.lineBreak,
    wordBreak: parent.style.overflowWrap === _overflowWrap.OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : parent.style.wordBreak
  });
  var words = [];
  var bk = void 0;

  while (!(bk = breaker.next()).done) {
    words.push(bk.value.slice());
  }

  return words;
};